enum DownloadButtonHandlingMethod {
    Download,
    Inline,
    Carousel
}

export default DownloadButtonHandlingMethod;